import {createTheme} from '@mui/material/styles';
import {blue, lime} from '@mui/material/colors';

const theme = createTheme({
	palette: {
		primary: lime,
		secondary: blue,
	},
});

export default theme;
